import { useEffect, useState } from "react";

const DEFAULT_BREAKPOINT = 768; // matches Tailwind `md`

// Return true when viewport is < breakpoint (mobile). Reactive to resizes and
// media query changes so layout swaps live (not just at mount).
export function useIsMobile(breakpoint = DEFAULT_BREAKPOINT) {
  const query = `(max-width: ${breakpoint - 1}px)`;

  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const mq = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    // Set current value immediately in case it changed between mount & effect
    setIsMobile(mq.matches);
    // Modern + Safari-legacy support
    if (mq.addEventListener) {
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    }
    mq.addListener(onChange);
    return () => mq.removeListener(onChange);
  }, [query]);

  return isMobile;
}
